export default __webpack_public_path__ + "static/media/swp_icon.ca4c8123.svg";